import {
  ProductPriceInfo,
  productPriceInfoFromResponse,
} from './ProductPriceInfo';

export interface ProductOptionValue {
  id: string;
  label: string;
  stock: number;
  image: string;
  price: ProductPriceInfo;
  specialPrice: number;
  priceType: 'fixed';
}

export const productOptionValueFromResponse = (
  responseData: any,
): ProductOptionValue => ({
  id: responseData.id,
  label: responseData.label,
  stock: responseData.stock,
  image: responseData.image,
  price: productPriceInfoFromResponse(responseData.price),
  specialPrice: responseData.special_price,
  priceType: responseData.price_type,
});

export interface ProductOption {
  id: number;
  name: string;
  values: ProductOptionValue[];
}

export const productOptionFromResponse = (
  responseData: any,
): ProductOption => ({
  id: responseData.id,
  name: responseData.name,
  values: responseData.values.map(productOptionValueFromResponse),
});
